export default __webpack_public_path__ + "static/media/icon-student-hat.1ec86042.svg";